import dayjs, { type ConfigType } from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";

dayjs.extend(isoWeek);

/**
 * ISO week key of a date, "2026-53": the ISO week-year (the year of that week's Thursday) and the
 * zero-padded ISO week. `client_nutrition_week.eventWeekIso` holds it, so readers compare it as a string.
 * Not `format("YYYY-WW")` - `YYYY` is the calendar year, which differs from the week's year around New Year.
 */
export const getIsoWeekKey = (date: ConfigType): string => {
  const day = dayjs(date);
  return `${day.isoWeekYear()}-${String(day.isoWeek()).padStart(2, "0")}`;
};
